import { render, staticRenderFns } from "./DataTablePagination.vue?vue&type=template&id=3fcb3c9a&scoped=true"
import script from "./DataTablePagination.vue?vue&type=script&lang=js"
export * from "./DataTablePagination.vue?vue&type=script&lang=js"
import style0 from "./DataTablePagination.vue?vue&type=style&index=0&id=3fcb3c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb3c9a",
  null
  
)

export default component.exports